import Loadable from 'react-loadable';
import { Spin } from 'antd';

const PageWorkOrder=Loadable({
  loader: () => import('../page/apartment/page_workorder'),
  loading: Spin,
})
const PageUserManager=Loadable({
  loader: () => import('../page/set/page_usermanager'),
  loading: Spin,
})

const PageService=Loadable({
  loader: () => import('../page/set/page_service'),
  loading: Spin,
})


const PagePlate=Loadable({
  loader: () => import('../page/apartment/page_plate'),
  loading: Spin,
})
const PageDevice = Loadable({
  loader: () => import('../page/device/page_device'),
  loading: Spin,
});
const PagePhone = Loadable({
  loader: () => import('../page/set/page_phone'),
  loading: Spin,
});
const PageAuth = Loadable({
  loader: () => import('../page/users/page_auth'),
  loading: Spin,
});
const PageLogin = Loadable({
  loader: () => import('../page/page_login/page_login'),
  loading: Spin,
});

const PageApartment = Loadable({
  loader: () => import('../page/apartment/page_apartment'),
  loading: Spin,
});
const PageBuilding = Loadable({
  loader: () => import('../page/apartment/page_building'),
  loading: Spin,
});
const PageUser = Loadable({
  loader: () => import('../page/users/page_user'),
  loading: Spin,
});
const PageThirdApp = Loadable({
  loader: () => import('../page/set/page_thirdapp'),
  loading: Spin,
});
const PageHome = Loadable({
  loader: () => import('../page/page_home/page_home'),
  loading: Spin,
});
const PageAnnouncement = Loadable({
  loader: () => import('../page/announcement/page_announcement'),
  loading: Spin,
});
export const mainRoutes = [{
  path: "/login",
  component: PageLogin,
}];
export const adminRoutes = [
  {
    title:"首页",
    icon: 'icon-xiaoquguanli',
    isshow: true,
    component:PageHome,
    path:'/admin/home'

  },
 
  {
    title: '小区管理',
    icon: 'icon-xiaoquguanli',
    isshow: true,
    child:[
      {
        title: '小区管理',
        isshow: true,
        shows:[1,2,3],
        icon: 'icon-xiaoquguanli',
        component:PageApartment,
        path:'/admin/apartment/apartment_list',
      },

      {
        title: '楼栋管理',
        isshow: true,
        shows:[1,2,3],
        icon: 'icon-loudongguanli',
        component:PageBuilding,
        path:'/admin/apartment/building_list',
      },
      {
        title: '车位管理',
        isshow: true,
        shows:[1,2,3],
        icon: 'icon-tingchewei',
        component:PagePlate,
        path:'/admin/apartment/plate_list',
      },
      {
        title: '工单管理',
        isshow: true,
        shows:[3],
        icon: 'icon-tingchewei',
        component:PageWorkOrder,
        path:'/admin/apartment/work_orders',
      },
    ]
  },
  {
    title: '住户管理',
    icon: 'icon-yonghu',
    isshow: true,
    child:[
      {
        title: '用户列表',
        isshow: true,
        shows:[1,2,3],
        icon: 'icon-yonghu',
        component:PageUser,
        path:'/admin/user/user_list',
      },
      {
        title: '用户认证',
        isshow: true,
        shows:[1,2,3],
        icon: 'icon-auth',
        component:PageAuth,
        path:'/admin/user/user_auth_list',
      },
    ]
  },
  //icon-bx-devices
  {
    title: '设备管理',
    icon: 'icon-bx-devices',
    isshow: true,
    child:[
      {
        title: '设备管理',
        isshow: true,
        shows:[1,2,3],
        icon: 'icon-bx-devices',
        component:PageDevice,
        path:'/admin/device/device_list',
      },
    ]
  },
  {
    title: '系统设置',
    icon: 'icon-shezhi',
    isshow: true,
    child:[
      {
        title: '系统用户管理',
        isshow: true,
        shows:[1],
        icon: 'icon-sanfangyingyong',
        component:PageUserManager,
        path:'/admin/setting/usermanager',
      },
      {
        title: '三方APP管理',
        isshow: true,
        shows:[1],
        icon: 'icon-sanfangyingyong',
        component:PageThirdApp,
        path:'/admin/setting/third_app_list',
      },
      {
        title: '电话管理',
        isshow: true,
        shows:[3],
        icon: 'icon-sanfangyingyong',
        component:PagePhone,
        path:'/admin/setting/phone_list',
      },
      {
        title: '公告管理',
        isshow: true,
        shows:[3],
        icon: 'icon-sanfangyingyong',
        component:PageAnnouncement,
        path:'/admin/setting/announcement_list',
      },
      {
        title: '物业服务内容',
        isshow: true,
        shows:[3],
        icon: 'icon-sanfangyingyong',
        component:PageService,
        path:'/admin/setting/service_wy',
      },
    ]
  },
];

